<template>
  <v-app style="background-color:#f8f9fb" >

    <v-dialog v-model="showProgress" persistent max-width="300">
      <v-card>
        <v-card-title>
          upload de arquivo...
        </v-card-title>
        <v-card-text>
          <!-- Coloque aqui qualquer indicador de progresso que você deseja mostrar -->
          <v-progress-linear indeterminate color="primary"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogConfirmacao" max-width="400">
    <v-card>
      <v-card-title class="headline">Confirmar Exclusão</v-card-title>
      <v-card-text>
        Tem certeza que deseja excluir esta importação?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" text @click="dialogConfirmacao = false">
          Cancelar
        </v-btn>
        <v-btn color="error" text @click="confirmarExclusao">
          Excluir
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

    <v-dialog v-model="showItens" persistent max-width="800px">
        <v-card>
          <v-card-title class="headline grey lighten-2">
            Lista das Vendas
          </v-card-title>

          <v-card-text>
            <v-data-table
              style="margin-top: 1rem;"
              :headers="ranking_itens"
              :items="lista_itens"
              :items-per-page="50" 
              items-per-page-text="Linhas por página"
              class="elevation-0"
            >
              <template v-slot:top>
                <v-progress-linear
                  v-if="isLoading" 
                  indeterminate
                  color="rgb(71 130 180)"
                ></v-progress-linear>
              </template>

              <template v-slot:item="row">
                <tr :class="{'cor-row': row.index % 2 !== 0}">
                  <td class="linha" style="width: 30%;font-size:14px;"> 
                    {{ row.item.produto }}
                  </td>
                  <td class="linha" style="width: 10%;font-size:14px;"> 
                    {{row.item.numeroNF}}
                  </td>
                  <td class="linha" style="width: 10%; font-size: 14px;">
                    {{ row.item.quantidade }} <br />
                  </td>
                  <td class="linha" style="width: 20%;font-size:14px;"> 
                    {{row.item.total}}
                  </td>
                  <td class="linha" style="width: 30%;font-size:14px;"> 
                    {{row.item.vendedor}}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>

          <v-card-actions class="justify-end">
            <v-btn 
              color="primary" 
              @click="showItens = false"
              class="mr-4 mb-4"
            >
              Fechar
            </v-btn>
          </v-card-actions>
        </v-card>

    </v-dialog>


    <v-divider></v-divider>
    <br/><br/>

    <v-snackbar
      v-model="snackbar"
      :vertical="vertical"
    >
      {{ text }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="indigo"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>


  <v-container style="background-color:#eee"  
    id="financeiro"
    fluid
    tag="section">
    <v-row >

      <v-col
        cols="12">

        <base-material-card
        icon="mdi-link-variant"
        title="Importação de Vendas do Radar"
        color="rgb(71 130 180)" style="margin-top:20px !important; padding-top:10px !important"
        class="px-5 py-0"> 

        <v-form ref="form" v-model="valid" lazy-validation>

          <v-row style="margin-top: 1rem;">

          <v-col
            class="d-flex"
            cols="12"
            sm="6">

            <v-select 
                :items="modelo"
                dense solo-inverted                                required
                :rules="[v => v != null && v !== '' || 'Este campo é obrigatório']"
                v-model=controle.modelo
                label="Modelo"
            ></v-select>

          </v-col>


          <v-col
            class="d-flex"
            cols="3"
            sm="3">
            <v-select
                :items="mes"
                dense solo-inverted      required
                :rules="[v => v != null && v !== '' || 'Este campo é obrigatório']"
                v-model=controle.mes
                label="Mês"
            ></v-select>

          </v-col>

          <v-col
            class="d-flex"
            cols="3"
            sm="3">
            <v-select 
                :items="ano"
                dense solo-inverted                                required
                :rules="[v => v != null && v !== '' || 'Este campo é obrigatório']"
                v-model=controle.ano
                label="Ano"
            ></v-select>

          </v-col>

          <v-col
            class="d-flex"
            cols="6"
            sm="6">

            <v-file-input 
                dense 
                solo-inverted 
                accept=".xls,.xlsx"
                label="Selecione o arquivo"
                v-model="controle.file"
                required
                :rules="[v => !!v || 'Arquivo é obrigatório']"
            ></v-file-input>

          </v-col>

         </v-row>
        
         <v-card-actions class="d-flex justify-end">
          <v-btn color="primary" @click="importarDados">         
            <v-icon left>mdi-content-save</v-icon> Salvar
             </v-btn>
        </v-card-actions>


      </v-form> 
       

         <v-data-table style="margin-top: 1rem;"
              :headers="ranking_header"
              :items="lista_controle"
              :items-per-page="50" 
              items-per-page-text="Linhas por página"
              class="elevation-0">
      
              <br/> <br/> <br/>
  
              <template v-slot:top>
                <v-progress-linear
                  v-if="isLoading" 
                  indeterminate
                  color="rgb(71 130 180)"
                ></v-progress-linear>
              </template>

                        <template v-slot:item="row">

                          <tr :class="{'cor-row': row.index % 2 !== 0}">
                                
                                <td class="linha" style="width: 20%;font-size:14px;"> 
                                  {{ row.item.empresa }}
                                </td>

                                <td class="linha" style="width: 15%;font-size:14px;"> 
                                  {{row.item.mes}} / {{row.item.ano}}
                                </td>


                                <td class="linha" style="width: 15%; font-size: 14px;">
                                   {{
                                      parseFloat(row.item.totalRecebido).toLocaleString('pt-BR', {
                                        style: 'currency',
                                        currency: 'BRL'
                                      })
                                    }}      
                                </td>
                               

                                <td class="linha" style="width: 15%;font-size:14px;"> 
                                  {{row.item.dataInsert}}
                                </td>

                                <td class="linha" style="width: 15%;font-size:14px;"> 
                                  {{row.item.userInsert}}
                                </td>

                                <td class="linha" style="width: 15%;font-size:14px;"> 
                                  <v-btn @click="excluirImportacao(row.item.id)" fab small  color="error">
                                    <v-icon dark>
                                      mdi-delete
                                    </v-icon>
                                  </v-btn>   
                                  
                                  <v-btn @click="getListaItens(row.item.id)" fab small  color="primary">
                                    <v-icon dark>
                                      mdi-eye
                                    </v-icon>
                                  </v-btn>   
                                </td>
                                
                          </tr>

                      </template>
              </v-data-table>

        </base-material-card>  

      </v-col>

  </v-row>
</v-container>

</v-app> 
</template>
<script>
  import VueApexCharts from "vue-apexcharts";
  import FiltroComponent from "./components/FiltroGeral.vue"; // Certifique-se de que o caminho esteja correto
  import Comissao from '../../services/comissao' 
  import { ContentLoader } from 'vue-content-loader'
  import VuetifyMoney from "./components/VuetifyMoney.vue";


  export default {
    name: 'Obitos',
    components: {
      apexcharts: VueApexCharts,
      FiltroComponent,
      ContentLoader,
      "vuetify-money": VuetifyMoney

    },

    created() {     
    },

    mounted() {
     this.getListaResumo();
    },

 
   
    data () {

      const dataAtual = new Date();
      const mesAtual = (dataAtual.getMonth() + 1).toString().padStart(2, '0'); // Formata o mês atual como "01", "02", etc.
      const anoAtual = dataAtual.getFullYear()+"";
      return {
        
          lista_vendedores: [],
          ranking_header: [
              { text: 'Empresa', value: 'empresa' },
              { text: 'Mês/Ano', value: 'mes' },
              { text: 'Recebido', value: 'totalRecebido' },
              { text: 'Data', value: 'data' },
              { text: 'Usuário', value: 'usuario' },
              { text: 'Ação', value: 'acao' },

            ],


          ranking_itens: [
              { text: 'Produto', value: 'produto' },
              { text: 'NF', value: 'numero_nf' },
              { text: 'Qtd', value: 'quantidade' },
              { text: 'Total', value: 'datotalta' },
              { text: 'Vendedor', value: 'vendedor' },
            ],

          lista_controle: [],
          lista_itens: [],
          produto: 'Todos',
          valid: false,
          label1: "Valor",
          controle: {
            modelo: null,
            mes: null,
            ano: null,
            file: null
          },
          snackbar: false,
          text: '',
          vertical: true,
          idParaExcluir: 0,
          dialogConfirmacao: false,
          isLoading: false,
          showFilterRegras: false,
          animationInterval: null, // Intervalo para controlar a animação
          empresa: '',
          selectedCompany: "Todas",
          selectedType: "Todos",
          selectedOpcao: "Todas",
          showFilter: false,
          showProgress: false,
          showItens: false,
          showFilterDownload: false,
          tipos: ["Todos"],
          mes: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"],
          ano: ["2024", "2025", "2026", "2027"],    
          modelo: ["Floricultura Previda", "Floricultura Melro", "Floricultura Memorial"],          

      }
    },
   
    methods: {


          limparCampos() {
            this.controle = {
              modelo: null,
              mes: null,
              ano: null,
              file: null
            };
            if (this.$refs.fileInput) {
              this.$refs.fileInput.reset();
            }
            if (this.$refs.form) {
              this.$refs.form.resetValidation();
            }
          },

         isPercentual(tipo) {
            return tipo === '%'
          },

          getListaResumo(){
              this.isLoading = true;

              Comissao.lista_venda_resumo()
                .then(response => {
                  if(response.status === 200){
                    this.lista_controle = response.data;  
                  } 
                })
                .catch(e => {    
                })
                .finally(() => {
                  this.isLoading = false;

                });
            },

            getListaItens(id){
              this.isLoading = true;

              Comissao.lista_venda_itens(id)
                .then(response => {
                  if(response.status === 200){
                    this.lista_itens = response.data;  
                  } 
                })
                .catch(e => {    
                })
                .finally(() => {
                  this.isLoading = false;
                  this.showItens = true;

                });
            },


     
          importarDados() {
              if (!this.$refs.form.validate()) {
                  return; // Não prossegue se o formulário não for válido
              }

              this.isLoading = true;
              this.showProgress = true,
 

              Comissao.importarVendas(
                  this.controle.file,
                  this.controle.modelo,
                  this.controle.ano,
                  this.controle.mes
                )
                .then(response => {
                  this.text = 'Dados importados com sucesso!';
                  this.snackbar = true;
                  this.limparCampos(); // Limpa os campos após sucesso

                })
                .catch(error => {
                  if (error.response) {
                    this.text = error.response.data || "Erro desconhecido";
                  } else if (error.request) {
                    this.text = "Sem resposta do servidor";
                  } else {
                    this.text = error.message || "Erro ao configurar a requisição";
                  }
                  
                  console.error("Erro detalhado:", error);
                  this.snackbar = true;
                })
                .finally(() => {
                  this.isLoading = false;
                  this.showProgress = false,
                  this.getListaResumo();
                });
          },

          excluirImportacao(id) {
            this.idParaExcluir = id;
            this.dialogConfirmacao = true;
          },
          
          confirmarExclusao() {
            this.dialogConfirmacao = false;
            this.isLoading = true;
            
            Comissao.excluirImportacao(this.idParaExcluir)
              .then(response => {
                if (response.status === 200) {
                  this.text = response.data;
                  this.getListaResumo(); // Atualiza a lista após exclusão
                }
              })
              .catch(error => {
                this.text = error.response?.data || "Erro ao excluir importação";
              })
              .finally(() => {
                this.isLoading = false;
                this.snackbar = true;
              });
          },
      
          clear () {
              this.$refs.form.reset();
          },

          formatPrice(value) {
              const val = Number(value.replace(",", "."));
              if (!val) return '0,00';
              const valueString = val.toFixed(2).replace(".", ",");
              return valueString.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
          }
    },
  }

</script>


<style scoped>
.v-progress-circular {
  margin: 1rem;
}

.custom-gray-background {
  height: 90px;
}

.row {
  display: flex;
  flex-wrap: wrap;
   flex: 0 1 auto !important; 
  margin: -12px;
}


/* Defina uma classe para preencher a largura horizontalmente e centralizar verticalmente */
.fill-width {
  width: 100%;
  margin-left: 0;
  margin-right: 0;
  display: flex;
}

.v-menu__content{
  box-shadow:none !important;
  top: 4px !important;
}
/* Centralize horizontalmente */
.justify-center {
  justify-content: center;
}

.gray-row {
  background-color: rgb(71 130 180); /* ou qualquer outra cor cinza que você preferir */
}
.cor-row {
  background-color: rgb(231 244 255)   ;
  transition: none !important; /* Desativa a transição de cor */

}


.linha{

    font-size: 11px !important;
    font-weight: bold;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
  }

  .no-hover-effect.v-data-table tbody tr:hover {
    color: #3055a4;
  }
.card-container {
  display: flex;
  justify-content: space-around; /* ou outro alinhamento que desejar */
}

</style>
